// extracted by mini-css-extract-plugin
export default {"bannerImage":"styles_bannerImage__No38L"};